<kendo-card class="modbusnetwork-card" >

  <kendo-card-header>

    <div><kendo-icon name="share"></kendo-icon> &nbsp; &nbsp; <small>Network branch     </small></div>
    <h1 kendoCardTitle> {{ connection?.name }}    </h1>
    <p kendoCardSubtitle>   </p>
  </kendo-card-header>

  <kendo-card-body class="modbusnetwork-card-body" >


    Connection: {{ connection?.network }} <br/>
    Status:  {{ connection ? connection.status : "Unknown" }}<br/>


  </kendo-card-body>
  <kendo-card-footer>
    <p><small>
    </small>
    </p>


  </kendo-card-footer>
</kendo-card>





